export default "__VITE_ASSET__Dl6qPm0E__"